import { render, staticRenderFns } from "./ExternRegistration.vue?vue&type=template&id=2028a017&"
import script from "./ExternRegistration.vue?vue&type=script&lang=js&"
export * from "./ExternRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports